import { createSlice } from "@reduxjs/toolkit";
import { fetchMccList, resolveMccByCode } from "./MccSelectField.thunk";

const initialState = {
  items: [],
  status: "idle",
  error: null,
  search: "",
  page: 0,
  pageSize: 50,
  totalRecords: 0,
  hasMore: false,
  resolvedByCode: {},
};

const mergeItems = (current, incoming) => {
  const merged = [...current];
  for (const item of incoming) {
    if (!merged.some((entry) => entry.id === item.id)) {
      merged.push(item);
    }
  }
  return merged;
};

export const mccSelectFieldSlice = createSlice({
  name: "mccSelectField",
  initialState,
  reducers: {
    resetMccCatalog: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMccList.pending, (state, action) => {
        state.error = null;
        state.status = action.meta.arg.append ? "loadingMore" : "loading";
      })
      .addCase(fetchMccList.fulfilled, (state, action) => {
        const { items, search, page, pageSize, totalRecords, append } =
          action.payload;
        state.search = search;
        state.page = page;
        state.pageSize = pageSize;
        state.totalRecords = totalRecords;
        state.items = append ? mergeItems(state.items, items) : items;
        state.hasMore = state.items.length < totalRecords;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(fetchMccList.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          action.payload?.message || action.error?.message || "Error loading MCC catalog";
      })
      .addCase(resolveMccByCode.fulfilled, (state, action) => {
        const item = action.payload;
        if (item?.id) {
          state.resolvedByCode[item.id] = item;
        }
      });
  },
});

export const { resetMccCatalog } = mccSelectFieldSlice.actions;
export default mccSelectFieldSlice.reducer;
